<template>
    <div>
        <hr>
        <div class="mt-3 component-comment">
            <div class="user mb-2">
                <img v-if="avatar" class="rounded-circle d-inline-block" :src="'/storage/profile/'+avatar" alt="avatar" style="width: 50px; height: 50px">
                <img v-else class="rounded-circle d-inline-block" src="/img/default-avatar.jpg" alt="avatar" style="width: 50px; height: 50px">
                <div class="d-inline-block pl-2">
                    <p class="d-block username m-0">{{title}}<span v-if="nuevo == true" class="badge badge-danger ml-1">Nuevo</span></p>
                    <span class="date">{{subtitle | moment("dddd, MMM Do YYYY")}}</span>
                </div>
            </div>
            <p class="text-justify comment">{{comment}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'title',
        'subtitle',
        'comment',
        'nuevo',
        'avatar',
    ],
}
</script>